module.exports = __webpack_public_path__ + "img/nav-logo.2c7b2ebd.png";